import { Link } from "@tanstack/react-router";
import type { MouseEventHandler, ReactNode } from "react";

type UserLinkProps = {
  /** User slug for the URL. Falls back to userId if slug is not available. */
  slug: string;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  children: ReactNode;
};

export function UserLink({ slug, className, onClick, children }: UserLinkProps) {
  return (
    <Link
      to="/app/users/$slug"
      params={{ slug }}
      target="_blank"
      className={className}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}
